import { useEffect, useRef } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export const PhotoLightbox = ({ photos, index, onIndex, onClose }) => {
  const touch = useRef(null);
  const n = photos.length;
  const go = (d) => onIndex((index + d + n) % n);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onIndex((index + 1) % n);
      if (e.key === "ArrowLeft") onIndex((index - 1 + n) % n);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [index, n, onClose, onIndex]);

  const onEnd = (e) => {
    if (touch.current == null) return;
    const dx = e.changedTouches[0].clientX - touch.current;
    touch.current = null;
    if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
  };

  const p = photos[index];
  return (
    <div className="fixed inset-0 z-[100] bg-black/95 flex flex-col select-none" data-testid="photo-lightbox"
      onTouchStart={(e) => { touch.current = e.touches[0].clientX; }} onTouchEnd={onEnd}>
      <div className="flex items-center justify-between px-4 py-3 text-white/90 text-sm">
        <span className="truncate" data-testid="lightbox-caption">{p.group} · {index + 1} / {n}</span>
        <button type="button" onClick={onClose} className="h-10 w-10 flex items-center justify-center rounded-full hover:bg-white/10" aria-label="Schließen" data-testid="lightbox-close">
          <X className="h-6 w-6" />
        </button>
      </div>
      <div className="flex-1 relative flex items-center justify-center overflow-hidden">
        <img key={p.src} src={p.src} alt="" className="max-h-full max-w-full object-contain animate-in fade-in duration-200" data-testid="lightbox-image" />
        {n > 1 && (
          <>
            <button type="button" onClick={() => go(-1)} className="absolute left-2 h-11 w-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center" aria-label="Vorheriges Bild" data-testid="lightbox-prev">
              <ChevronLeft className="h-6 w-6" />
            </button>
            <button type="button" onClick={() => go(1)} className="absolute right-2 h-11 w-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center" aria-label="Nächstes Bild" data-testid="lightbox-next">
              <ChevronRight className="h-6 w-6" />
            </button>
          </>
        )}
      </div>
      <div className="py-3 text-center text-white/50 text-xs">Wischen zum Blättern</div>
    </div>
  );
};
